import React, { useEffect, useMemo, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthGuard from "./components/AuthGuard";
import Layout from "./components/Layout";
import AgendaPage from "./pages/AgendaPage";
import BenefitsPage from "./pages/BenefitsPage";
import AdminPage from "./pages/AdminPage";
import ProfilePage from "./pages/ProfilePage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import LoginPage from "./pages/LoginPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import useAuth from "./hooks/useAuth";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/*" element={
          <AuthGuard>
            <AppRoutes />
          </AuthGuard>
        } />
      </Routes>
    </Router>
  );
}

function AppRoutes() {
  const { isAdmin } = useAuth();

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<AgendaPage />} />
        <Route path="/beneficios" element={<BenefitsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/admin" element={
          <AuthGuard>
            <AdminPage />
          </AuthGuard>
        } />
      </Routes>
    </Layout>
  );
}